import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Alert, Modal, ModalBody, ModalHeader, Spinner } from "reactstrap";
import PhoneInput from "react-phone-input-2";
import { Button, Col, Icon, RSelect, Row } from "../../../../components/Component";
import { retrieve_specific_country_all_user_kyc_det_action } from "../../../../actions/dashboard_actions/locations/locations_actions";
import { makeEmployeeDashboardApiRequest } from "../../../../api/api_helper";
import {
  UPDATE_ADDRESS_KYC_INFO,
  UPDATE_DOCUMENT_KYC_INFO,
  UPDATE_USER_MAIN_DETAIL_API,
} from "../../../../api/api_data";
import * as app_consts from "../../../../constants/react_app_consts";
import {
  UPDATE_ADDRESS_KYC_INFO_ERR_MSG,
  UPDATE_ADDRESS_KYC_INFO_SUCCESS_MSG,
  UPDATE_DOCUMENT_KYC_INFO_SUCCESS_MSG,
  UPDATE_DOCUMENT_KYC_INFO_ERR_MSG,
  UPDATE_USER_MAIN_DETAILS_ERR_MSG,
  UPDATE_USER_MAIN_DETAILS_SUCCESS_MSG,
} from "../../../../constants/success_error_messages_consts";
import { reset_specific_country_all } from "../../../../reducers/dashboard_reducers/location/specific_country_all_Slice";
import TextInput from "../../../components/inputs/TextInput";
import { messageToast } from "../../../../utils/Utils";
import {
  EMAIL_REGEX,
  NOT_NULL_LETTERS_ONLY_STRING,
  NRC_REGEX,
  NUMBERS_ONLY_REGEX,
  ZAMIBAN_PHONE_NUMBER_REGEX,
} from "../../../../utils/RegexUtils";

const initialState = {
  first_name: "",
  middle_name: "",
  surname: "",
  phone_number: "",
  email_address: "",
  iso_code_2: app_consts.DEFAULT_ISO_CODE_2,
  new_phone_number: "",
  address: "",
  country: "",
  district: "",
  id_number: "",
  tpin: "",
};

const extractApiErrorMessage = (error, fallbackMessage) => {
  const responseData = error?.response?.data;

  if (responseData?.message) {
    return responseData.message;
  }

  if (responseData?.errors?.detail) {
    return responseData.errors.detail;
  }

  if (responseData?.errors && typeof responseData.errors === "object") {
    const firstErrorValue = Object.values(responseData.errors)[0];

    if (Array.isArray(firstErrorValue) && firstErrorValue.length > 0) {
      return firstErrorValue[0];
    }

    if (typeof firstErrorValue === "string" && firstErrorValue.trim()) {
      return firstErrorValue;
    }
  }

  return fallbackMessage;
};

const assertApiSuccess = (response, expectedMessage, fallbackMessage) => {
  const responseMessage = response?.data?.message;

  if (expectedMessage && responseMessage !== expectedMessage) {
    throw new Error(responseMessage || fallbackMessage);
  }
};

const mapDistrictsByProvince = (districts = [], provinceId) =>
  districts
    .filter((district) => district.province_id === provinceId)
    .map((district) => ({
      label: district.district_name,
      value: district.district_id,
    }));

const EditUserMainDetailsModal = ({ isOpen, cloasModal, successFunction, data }) => {
  const dispatch = useDispatch();

  const [formData, setFormData] = useState(initialState);
  const [initialData, setInitialData] = useState(initialState);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [submitError, setSubmitError] = useState("");

  const [fName, setFName] = useState("");
  const [validFName, setValidFName] = useState(false);
  const [inputFNameFocus, setInputFNameFocus] = useState(false);

  const [mName, setMName] = useState("");
  const [validMName, setValidMName] = useState(true);
  const [inputMNameFocus, setInputMNameFocus] = useState(false);

  const [sName, setSName] = useState("");
  const [validSName, setValidSName] = useState(false);
  const [inputSNameFocus, setInputSNameFocus] = useState(false);

  const [emailAddress, setEmailAddress] = useState("");
  const [validEmailAddress, setValidEmailAddress] = useState(true);
  const [inputEmailAddressFocus, setInputEmailAddressFocus] = useState(false);

  const [newPhoneNumber, setNewPhoneNumber] = useState("");
  const [newPhoneNumberFocus, setNewPhoneNumberFocus] = useState(false);
  const [confirmPhoneNumber, setConfirmPhoneNumber] = useState("");
  const [confirmPhoneNumberFocus, setConfirmPhoneNumberFocus] = useState(false);

  const [idNumber, setIdNumber] = useState("");
  const [inputIdNumberFocus, setInputIdNumberFocus] = useState(false);

  const [tpin, setTpin] = useState("");
  const [inputTpinFocus, setInputTpinFocus] = useState(false);

  const [provinceOptions, setProvinceOptions] = useState([]);
  const [districtRecords, setDistrictRecords] = useState([]);
  const [districtOptions, setDistrictOptions] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState(null);
  const [selectedDistrictOption, setSelectedDistrictOption] = useState(null);
  const [currentDistrictId, setCurrentDistrictId] = useState("");
  const [hasTouchedDistrictControls, setHasTouchedDistrictControls] = useState(false);
  useEffect(() => {
    if (!data || !isOpen) {
      return;
    }

    const receivedIsoCode = data?.iso_code_2 || app_consts.DEFAULT_ISO_CODE_2;
    const nextState = {
      first_name: data?.first_name || "",
      middle_name: data?.middle_name || "",
      surname: data?.surname || "",
      phone_number: data?.phone_number || "",
      email_address: data?.email_address || "",
      iso_code_2: receivedIsoCode,
      new_phone_number: "",
      address: data?.address || "",
      country: data?.country || "",
      district: data?.district || "",
      id_number: data?.id_number || "",
      tpin: data?.tpin || "",
    };

    setFormData(nextState);
    setInitialData(nextState);

    setFName(nextState.first_name);
    setMName(nextState.middle_name);
    setSName(nextState.surname);
    setEmailAddress(nextState.email_address);
    setIdNumber(nextState.id_number);
    setTpin(nextState.tpin);

    setNewPhoneNumber("");
    setConfirmPhoneNumber("");
    setSubmitError("");

    setInputFNameFocus(false);
    setInputMNameFocus(false);
    setInputSNameFocus(false);
    setInputEmailAddressFocus(false);
    setNewPhoneNumberFocus(false);
    setConfirmPhoneNumberFocus(false);
    setInputIdNumberFocus(false);
    setInputTpinFocus(false);

    setProvinceOptions([]);
    setDistrictRecords([]);
    setDistrictOptions([]);
    setSelectedProvince(null);
    setSelectedDistrictOption(null);
    setCurrentDistrictId("");
    setHasTouchedDistrictControls(false);
    if (receivedIsoCode === app_consts.DEFAULT_ISO_CODE_2 && data?.phone_number) {
      dispatch(retrieve_specific_country_all_user_kyc_det_action(app_consts.MAP, { phone_number: data.phone_number }));
    }
  }, [data, dispatch, isOpen]);

  useEffect(() => {
    setValidFName(NOT_NULL_LETTERS_ONLY_STRING.test(fName));
  }, [fName]);

  useEffect(() => {
    if (!mName) {
      setValidMName(true);
      return;
    }

    setValidMName(NOT_NULL_LETTERS_ONLY_STRING.test(mName));
  }, [mName]);

  useEffect(() => {
    setValidSName(NOT_NULL_LETTERS_ONLY_STRING.test(sName));
  }, [sName]);

  useEffect(() => {
    if (!emailAddress) {
      setValidEmailAddress(true);
      return;
    }

    setValidEmailAddress(EMAIL_REGEX.test(emailAddress));
  }, [emailAddress]);

  const isZambianUser = formData.iso_code_2 === app_consts.DEFAULT_ISO_CODE_2;

  const isNewPhoneNumberValid = useMemo(
    () => (isZambianUser ? ZAMIBAN_PHONE_NUMBER_REGEX.test(newPhoneNumber) : Boolean(newPhoneNumber?.trim())),
    [isZambianUser, newPhoneNumber]
  );

  const isConfirmPhoneNumberValid = useMemo(
    () =>
      isZambianUser ? ZAMIBAN_PHONE_NUMBER_REGEX.test(confirmPhoneNumber) : Boolean(confirmPhoneNumber?.trim()),
    [confirmPhoneNumber, isZambianUser]
  );

  const hasStartedPhoneChange = useMemo(
    () => Boolean(newPhoneNumber?.trim() || confirmPhoneNumber?.trim()),
    [confirmPhoneNumber, newPhoneNumber]
  );

  const doPhoneNumbersMatch = useMemo(
    () => Boolean(newPhoneNumber && confirmPhoneNumber && newPhoneNumber === confirmPhoneNumber),
    [confirmPhoneNumber, newPhoneNumber]
  );

  const didIdNumberChange = formData.id_number !== initialData.id_number;
  const isIdNumberValid = !didIdNumberChange
    ? true
    : isZambianUser
      ? NRC_REGEX.test(formData.id_number)
      : Boolean(formData.id_number?.trim());

  const didTpinChange = formData.tpin !== initialData.tpin;
  const isTpinValid =
    !isZambianUser || !didTpinChange
      ? true
      : formData.tpin?.length === 10 && NUMBERS_ONLY_REGEX.test(formData.tpin);

  const submittedDistrictId =
    selectedDistrictOption?.value || (hasTouchedDistrictControls ? "" : currentDistrictId);
  const hasAddressChanges =
    formData.address !== initialData.address || Boolean(selectedDistrictOption?.value);
  const isAddressValid =
    !hasAddressChanges || (Boolean(formData.address?.trim()) && (!isZambianUser || Boolean(submittedDistrictId)));

  const hasDocumentChanges =
    formData.id_number !== initialData.id_number || formData.tpin !== initialData.tpin;

  const hasMainDetailChanges =
    formData.first_name !== initialData.first_name ||
    formData.middle_name !== initialData.middle_name ||
    formData.surname !== initialData.surname ||
    formData.email_address !== initialData.email_address ||
    newPhoneNumber !== "";

  const shouldEditMainDetails = true;
  const shouldEditAddressDetails = true;
  const shouldEditDocumentDetails = true;
  const isPhoneSectionValid =
    !hasStartedPhoneChange || (isNewPhoneNumberValid && isConfirmPhoneNumberValid && doPhoneNumbersMatch);
  const hasVisibleChanges =
    (shouldEditMainDetails && hasMainDetailChanges) ||
    (shouldEditAddressDetails && hasAddressChanges) ||
    (shouldEditDocumentDetails && hasDocumentChanges);

  const currentCountryCode = String(formData.iso_code_2 || app_consts.DEFAULT_ISO_CODE_2).toLowerCase();

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "first_name") {
      setFName(value);
    } else if (name === "middle_name") {
      setMName(value);
    } else if (name === "surname") {
      setSName(value);
    } else if (name === "email_address") {
      setEmailAddress(value);
    } else if (name === "id_number") {
      setIdNumber(value);
    } else if (name === "tpin") {
      setTpin(value);
    }

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handlePhoneNumberChange = (value, phone) => {
    const isoCode = phone?.countryCode ? phone.countryCode.toUpperCase() : app_consts.DEFAULT_ISO_CODE_2;

    setNewPhoneNumber(value);
    setFormData((prevState) => ({
      ...prevState,
      iso_code_2: isoCode,
      new_phone_number: value,
    }));
  };

  const handleConfirmPhoneNumberChange = (value) => {
    setConfirmPhoneNumber(value);
  };

  const handleProvinceChange = (option) => {
    setHasTouchedDistrictControls(true);
    setSelectedProvince(option);
    setDistrictOptions(mapDistrictsByProvince(districtRecords, option?.value));
    setSelectedDistrictOption(null);
  };

  const handleDistrictChange = (option) => {
    setHasTouchedDistrictControls(true);
    setSelectedDistrictOption(option);
  };

  const specificCountryAll = useSelector((state) => state.specific_country_all.specific_country_all);

  useEffect(() => {
    if (specificCountryAll.status === app_consts.IDLE || specificCountryAll.status === app_consts.LOADING) {
      return;
    }

    if (specificCountryAll.status === app_consts.FAIL) {
      messageToast(specificCountryAll.message, app_consts.FAIL);
      dispatch(reset_specific_country_all());
      return;
    }

    const provinces = specificCountryAll.data?.provinces || [];
    const districts = specificCountryAll.data?.districts || [];
    const matchedDistrict = districts.find(
      (district) =>
        String(district?.district_name || "").trim().toLowerCase() ===
        String(initialData.district || "").trim().toLowerCase()
    );

    setProvinceOptions(provinces);
    setDistrictRecords(districts);

    if (matchedDistrict) {
      const matchedProvince = provinces.find((province) => province.value === matchedDistrict.province_id) || null;
      setCurrentDistrictId(matchedDistrict.district_id);
      setSelectedProvince(matchedProvince);
      setDistrictOptions(mapDistrictsByProvince(districts, matchedDistrict.province_id));
    }

    dispatch(reset_specific_country_all());
  }, [dispatch, initialData.district, specificCountryAll]);

  const saveUserChanges = async () => {
    setSubmitError("");
    setSubmitLoading(true);

    try {
      if (shouldEditDocumentDetails && hasDocumentChanges) {
        const documentPayload = {
          phone_number: initialData.phone_number,
          id_number: formData.id_number,
          tpin: isZambianUser ? formData.tpin : "",
        };

        const response = await makeEmployeeDashboardApiRequest(
          app_consts.POST,
          UPDATE_DOCUMENT_KYC_INFO,
          documentPayload
        );

        assertApiSuccess(
          response,
          UPDATE_DOCUMENT_KYC_INFO_SUCCESS_MSG,
          UPDATE_DOCUMENT_KYC_INFO_ERR_MSG
        );
      }

      if (shouldEditAddressDetails && hasAddressChanges) {
        const addressPayload = {
          phone_number: initialData.phone_number,
          address: formData.address,
          ...(isZambianUser ? { district_id: submittedDistrictId } : {}),
        };

        const response = await makeEmployeeDashboardApiRequest(
          app_consts.POST,
          UPDATE_ADDRESS_KYC_INFO,
          addressPayload
        );

        assertApiSuccess(
          response,
          UPDATE_ADDRESS_KYC_INFO_SUCCESS_MSG,
          UPDATE_ADDRESS_KYC_INFO_ERR_MSG
        );
      }

      if (shouldEditMainDetails && hasMainDetailChanges) {
        const mainDetailsPayload = {
          first_name: formData.first_name,
          middle_name: formData.middle_name,
          surname: formData.surname,
          phone_number: initialData.phone_number,
          email_address: formData.email_address,
          iso_code_2: formData.iso_code_2,
          new_phone_number: formData.new_phone_number,
        };

        const mainDetailsResponse = await makeEmployeeDashboardApiRequest(
          app_consts.POST,
          UPDATE_USER_MAIN_DETAIL_API,
          mainDetailsPayload
        );

        assertApiSuccess(
          mainDetailsResponse,
          UPDATE_USER_MAIN_DETAILS_SUCCESS_MSG,
          UPDATE_USER_MAIN_DETAILS_ERR_MSG
        );
      }

      const updatedPhoneNumber = formData.new_phone_number || initialData.phone_number;
      messageToast(UPDATE_USER_MAIN_DETAILS_SUCCESS_MSG, app_consts.SUCCESS);
      successFunction(updatedPhoneNumber);
      cloasModal();
    } catch (error) {
      const fallbackMessage = error?.message || UPDATE_USER_MAIN_DETAILS_ERR_MSG;
      const errorMessage = extractApiErrorMessage(error, fallbackMessage);
      setSubmitError(errorMessage);
      messageToast(errorMessage, app_consts.FAIL);
    } finally {
      setSubmitLoading(false);
    }
  };

  const isSubmitDisabled =
    submitLoading ||
    (shouldEditMainDetails && (!validFName || !validMName || !validSName || !validEmailAddress)) ||
    (shouldEditMainDetails && !isPhoneSectionValid) ||
    (shouldEditDocumentDetails && (!isIdNumberValid || !isTpinValid)) ||
    (shouldEditAddressDetails && !isAddressValid) ||
    !hasVisibleChanges;

  return (
    <Modal isOpen={isOpen} className="modal-dialog-centered" size="xl">
      <ModalHeader toggle={!submitLoading ? cloasModal : undefined}>Edit User Details</ModalHeader>
      <ModalBody>
        <form
          onSubmit={(e) => {
            e.preventDefault();
          }}
        >
          <Row className="g-4">
            <Col lg="12">
              <div className="border rounded-3 p-3 bg-light">
                <h6 className="mb-1">Main Details</h6>
                <p className="text-soft mb-3">Edit the user's names, email address, and phone number.</p>
                <Row className="g-4">
                  <TextInput
                    label="First Name"
                    required
                    type="text"
                    id_val="first_name"
                    maxlength="30"
                    value={formData.first_name}
                    colSize="4"
                    name="first_name"
                    handleChange={handleChange}
                    error_stat={inputFNameFocus && Boolean(fName) && !validFName}
                    err_Msg="First Name should only be one name and should not contain any whitespace"
                    onFocus={() => setInputFNameFocus(true)}
                  />

                  <TextInput
                    label="Middle Name (Optional)"
                    id_val="middle_name"
                    maxlength="30"
                    type="text"
                    value={formData.middle_name}
                    colSize="4"
                    name="middle_name"
                    handleChange={handleChange}
                    error_stat={inputMNameFocus && Boolean(mName) && !validMName}
                    err_Msg="Middle Name should only be one name and should not contain any whitespace"
                    onFocus={() => setInputMNameFocus(true)}
                  />

                  <TextInput
                    label="Surname"
                    id_val="surname"
                    required
                    maxlength="30"
                    type="text"
                    value={formData.surname}
                    colSize="4"
                    name="surname"
                    handleChange={handleChange}
                    error_stat={inputSNameFocus && Boolean(sName) && !validSName}
                    err_Msg="Surname should only be one name and should not contain any whitespace"
                    onFocus={() => setInputSNameFocus(true)}
                  />

                  <TextInput
                    label="Email Address"
                    id_val="email_address"
                    maxlength="160"
                    type="email"
                    value={formData.email_address}
                    colSize="6"
                    name="email_address"
                    handleChange={handleChange}
                    error_stat={inputEmailAddressFocus && Boolean(emailAddress) && !validEmailAddress}
                    err_Msg="Please insert a valid email address."
                    onFocus={() => setInputEmailAddressFocus(true)}
                  />

                  <TextInput
                    label="Current Phone Number"
                    id_val="phone_number"
                    type="text"
                    value={initialData.phone_number}
                    colSize="6"
                    name="phone_number"
                    handleChange={() => {}}
                    disabled
                  />

                  <Col lg="6">
                    <div className="form-group">
                      <div className="form-label-group">
                        <label className="form-label" htmlFor="new_phone_number">
                          New Phone Number
                        </label>
                      </div>
                      <div className="form-control-wrap">
                        <PhoneInput
                          country={currentCountryCode}
                          value={newPhoneNumber}
                          onChange={handlePhoneNumberChange}
                          copyNumbersOnly={false}
                          inputStyle={{ width: "100%" }}
                          inputProps={{
                            id: "new_phone_number",
                            name: "new_phone_number",
                            onFocus: () => setNewPhoneNumberFocus(true),
                          }}
                        />
                      </div>
                      <span className="text-soft d-block mt-1">
                        Leave both phone fields blank if you do not want to change the number.
                      </span>
                      {newPhoneNumberFocus && newPhoneNumber && !isNewPhoneNumberValid ? (
                        <span className="text-danger d-block mt-1">Please enter a valid phone number.</span>
                      ) : null}
                    </div>
                  </Col>

                  <Col lg="6">
                    <div className="form-group">
                      <div className="form-label-group">
                        <label className="form-label" htmlFor="confirm_new_phone_number">
                          Confirm New Phone Number
                        </label>
                      </div>
                      <div className="form-control-wrap">
                        <PhoneInput
                          country={currentCountryCode}
                          value={confirmPhoneNumber}
                          onChange={handleConfirmPhoneNumberChange}
                          copyNumbersOnly={false}
                          inputStyle={{ width: "100%" }}
                          inputProps={{
                            id: "confirm_new_phone_number",
                            name: "confirm_new_phone_number",
                            onFocus: () => setConfirmPhoneNumberFocus(true),
                          }}
                        />
                      </div>
                      {confirmPhoneNumberFocus && confirmPhoneNumber && !isConfirmPhoneNumberValid ? (
                        <span className="text-danger d-block mt-1">Please enter a valid phone number.</span>
                      ) : null}
                      {confirmPhoneNumberFocus && confirmPhoneNumber && isConfirmPhoneNumberValid && !doPhoneNumbersMatch ? (
                        <span className="text-danger d-block mt-1">The confirmation number must match the new number.</span>
                      ) : null}
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>

            <Col lg="12">
              <div className="border rounded-3 p-3 bg-light">
                <h6 className="mb-1">Address Details</h6>
                <p className="text-soft mb-3">Edit the user's physical address and district information.</p>
                <Row className="g-4">
                  <TextInput
                    label="Country"
                    id_val="country"
                    type="text"
                    value={formData.country}
                    colSize="4"
                    name="country"
                    handleChange={() => {}}
                    disabled
                  />

                  <TextInput
                    label="Current District"
                    id_val="district"
                    type="text"
                    value={formData.district || "---"}
                    colSize="4"
                    name="district"
                    handleChange={() => {}}
                    disabled
                  />

                  <TextInput
                    label="Address"
                    id_val="address"
                    type="text"
                    value={formData.address}
                    colSize="4"
                    name="address"
                    handleChange={handleChange}
                    maxlength="100"
                  />

                  {isZambianUser ? (
                    <>
                      <Col lg="6">
                        <div className="form-group">
                          <label className="form-label" htmlFor="province_state">
                            Province
                          </label>
                          <div className="form-control-wrap">
                            <RSelect
                              options={provinceOptions}
                              value={selectedProvince}
                              className="w-100"
                              id="province_state"
                              isClearable
                              onChange={handleProvinceChange}
                            />
                          </div>
                        </div>
                      </Col>

                      <Col lg="6">
                        <div className="form-group">
                          <label className="form-label" htmlFor="district_id">
                            New District
                          </label>
                          <div className="form-control-wrap">
                            <RSelect
                              options={districtOptions}
                              value={selectedDistrictOption}
                              className="w-100"
                              id="district_id"
                              isClearable
                              onChange={handleDistrictChange}
                            />
                          </div>
                          {hasAddressChanges && !submittedDistrictId ? (
                            <span className="text-danger d-block mt-1">Please select a district before saving address changes.</span>
                          ) : null}
                        </div>
                      </Col>
                    </>
                  ) : null}
                </Row>
              </div>
            </Col>

            <Col lg="12">
              <div className="border rounded-3 p-3 bg-light">
                <h6 className="mb-1">Document Details</h6>
                <p className="text-soft mb-3">Edit the user's identification and tax document details.</p>
                <Row className="g-4">
                  <TextInput
                    label={isZambianUser ? "NRC Number" : "Passport Number"}
                    id_val="id_number"
                    type="text"
                    value={formData.id_number}
                    colSize={isZambianUser ? "6" : "12"}
                    name="id_number"
                    handleChange={handleChange}
                    error_stat={inputIdNumberFocus && Boolean(idNumber) && !isIdNumberValid}
                    err_Msg="ID Number should be in the format 123456/12/1 for Zambian users."
                    onFocus={() => setInputIdNumberFocus(true)}
                  />

                  {isZambianUser ? (
                    <TextInput
                      label="TPIN"
                      id_val="tpin"
                      type="text"
                      maxlength="10"
                      minlength="10"
                      value={formData.tpin}
                      colSize="6"
                      name="tpin"
                      handleChange={handleChange}
                      error_stat={inputTpinFocus && Boolean(tpin) && !isTpinValid}
                      err_Msg="TPIN should contain 10 numeric characters."
                      onFocus={() => setInputTpinFocus(true)}
                    />
                  ) : null}
                </Row>
              </div>
            </Col>

            {submitError ? (
              <div className="mb-3">
                <Alert color="danger" className="alert-icon">
                  <Icon name="alert-circle" />
                  {submitError}
                </Alert>
              </div>
            ) : null}

            <Col xl="12" className="d-flex justify-content-end">
              <Button
                onClick={saveUserChanges}
                size="lg"
                type="submit"
                color="primary"
                disabled={isSubmitDisabled}
              >
                {submitLoading ? <Spinner size="sm" color="light" /> : "Save User Details"}
              </Button>
            </Col>
          </Row>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default EditUserMainDetailsModal;
